import React from 'react';
import { getNumberColor } from '../utils/roulette';

export const BettingTable = ({ onPlaceBet, currentBets = [], isSpinning }) => {
  const getBetAmount = (betKey) => {
    const keyStr = String(betKey);
    return currentBets
      .filter((b) => String(b.betKey) === keyStr || String(b.value) === keyStr)
      .reduce((sum, b) => sum + (b.amount || 0), 0);
  };

  const renderCell = (betKey, label, customClass = '') => {
    const betAmount = getBetAmount(betKey);

    return (
      <button
        key={betKey}
        type="button"
        disabled={isSpinning}
        onClick={() => onPlaceBet(betKey)}
        className={`relative flex items-center justify-center font-bold text-sm md:text-base border border-black/30 shadow-md transition-all select-none
          ${isSpinning ? 'opacity-70 cursor-not-allowed' : 'hover:border-[#e5b849] hover:scale-[1.02] active:scale-95 cursor-pointer'} 
          ${customClass}`}
      >
        <span className="relative z-10">{label}</span>
        {betAmount > 0 && (
          <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/40 rounded-md backdrop-blur-[1px]">
            <div className="w-7 h-7 md:w-8 md:h-8 rounded-full bg-[#e5b849] border-2 border-white text-black text-[10px] md:text-xs font-black flex items-center justify-center shadow-lg transform scale-110">
              ${betAmount}
            </div>
          </div>
        )}
      </button>
    );
  };

  const numbers = Array.from({ length: 36 }, (_, i) => i + 1);

  return (
    <div className="w-full select-none max-w-4xl mx-auto flex flex-col md:flex-row gap-3">
      {/* Zero Cell */}
      <div className="w-full md:w-16 flex-shrink-0">
        <button
          type="button"
          disabled={isSpinning}
          onClick={() => onPlaceBet('0')}
          className={`relative w-full h-16 md:h-full flex items-center justify-center font-bold text-lg border border-black/30 shadow-md transition-all rounded-xl md:rounded-l-xl bg-[#047857] text-white
            ${isSpinning ? 'opacity-70 cursor-not-allowed' : 'hover:border-[#e5b849] hover:scale-[1.02] cursor-pointer'}`}
        >
          <span className="relative z-10">0</span>
          {getBetAmount('0') > 0 && (
            <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/40 rounded-xl backdrop-blur-[1px]">
              <div className="w-7 h-7 rounded-full bg-[#e5b849] border-2 border-white text-black text-xs font-black flex items-center justify-center shadow-lg">
                ${getBetAmount('0')}
              </div>
            </div>
          )}
        </button>
      </div>

      {/* Main Grid */}
      <div className="flex-1 flex flex-col gap-3">
        {/* Numbers 1-36 */}
        <div className="grid grid-cols-3 gap-2">
          {numbers.map((num) => {
            const color = getNumberColor(num);
            const bgClass = color === 'red' ? 'bg-[#b91c1c] text-white' : 'bg-[#111827] text-white';
            return renderCell(String(num), String(num), `${bgClass} h-12 md:h-14 rounded-lg`);
          })}
        </div>

        {/* Dozens */}
        <div className="grid grid-cols-3 gap-2">
          {renderCell('1st12', '1st 12', 'bg-[#1f293d] text-amber-400 h-12 md:h-14 rounded-lg border border-amber-500/20')}
          {renderCell('2nd12', '2nd 12', 'bg-[#1f293d] text-amber-400 h-12 md:h-14 rounded-lg border border-amber-500/20')}
          {renderCell('3rd12', '3rd 12', 'bg-[#1f293d] text-amber-400 h-12 md:h-14 rounded-lg border border-amber-500/20')}
        </div>

        {/* Outside Bets */}
        <div className="grid grid-cols-3 sm:grid-cols-6 gap-2">
          {renderCell('1-18', '1-18', 'bg-[#1f293d] text-gray-200 h-12 md:h-14 rounded-lg')}
          {renderCell('even', 'EVEN', 'bg-[#1f293d] text-gray-200 h-12 md:h-14 rounded-lg')}
          {renderCell('red', 'RED', 'bg-[#b91c1c] text-white h-12 md:h-14 rounded-lg')}
          {renderCell('black', 'BLACK', 'bg-[#111827] text-white h-12 md:h-14 rounded-lg')}
          {renderCell('odd', 'ODD', 'bg-[#1f293d] text-gray-200 h-12 md:h-14 rounded-lg')}
          {renderCell('19-36', '19-36', 'bg-[#1f293d] text-gray-200 h-12 md:h-14 rounded-lg')}
        </div>
      </div>
    </div>
  );
};
